import isArray from 'lodash/isArray';
import isFinite from 'lodash/isFinite';
import isUndefined from 'lodash/isUndefined';
import moment from 'moment';
import {getAsString, getCollection, getId} from '../../core-utilities/domain/ReduxUtils';
import {ViewMode} from '../../core-utilities/enums/ViewMode';
import {getTaskDate} from '../../tasks/domain/$$AbstractTask';


const ONE_MIN = 60 * 1000;
const ONE_HOUR = 60 * 60 * 1000;
const ONE_DAY = 24 * 60 * 60 * 1000;

export function floorMonth(millis) {
  const date = new Date(millis);
  const year = date.getFullYear();
  const month = date.getMonth();
  return new Date(Date.UTC(year, month, 1, 0, 0, 0)).getTime() / 1000 / 60;
}

// This method must be kept in sync with what data the server sends to the client about the assignedTo person/team
export function getAssignedTo(assignedTo) {
  return assignedTo ? {
    id: getId(assignedTo),
    collection: getCollection(assignedTo),
    name: getAsString(assignedTo),
    avc: assignedTo.getAvatarIndex ? assignedTo.getAvatarIndex() : assignedTo.avc,
  } : null;
}

export function assignedToEquals(a1, a2) {
  if (!a1 && !a2) {
    return true;
  } else if (!!a1 !== !!a2) {
    return false;
  } else {
    const a1Id = getId(a1.id);
    const a2Id = getId(a2.id);
    return a1Id === a2Id;
  }
}

export function getResponse(response) {
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.indexOf('application/json') !== -1) {
    return response.json();
  } else {
    return response.text();
  }
}

export function convertResponse(r) {
  if (isArray(r)) {
    // state -> success
    return r.map(convertToEvent);
  } else {
    // state -> error, probably
    return r;
  }
}

export function convertToEvent(task) {
  try {
    const duration = getTaskDuration(task);
    const event = {title: task.name, task: task};
    if (!task.useTime && duration <= ONE_DAY) {
      // In this case the task has been nebulously defined to finish some time on this day
      event.allDay = true;
      event.start = new Date(getTaskDate(task));
      event.start.setHours(0, 0, 0, 0);
      event.end = new Date(event.start.getTime() + duration);
    } else {
      // Otherwise, the scheduled date is when the task is supposed to be completed so any duration happens prior
      event.end = new Date(getTaskDate(task));
      event.start = new Date(event.end.getTime() - duration);
    }
    return event;
  } catch (e) {
    console.error(e);
    return {};
  }
}

export function getTaskDuration(task) {
  // if task.duration == 0, we ignore it
  const duration = isFinite(task.duration) ? task.duration : 0;
  if (task.useTime && duration === 0) {
    return ONE_HOUR;
  } else if (!task.useTime && duration === 0) {
    return ONE_DAY;
  } else {
    return duration * ONE_MIN;
  }
}

export function getDateRange(date) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const startDate = moment([year, month]);
  const endDate = moment(startDate).endOf('month');
  startDate.add(-7, 'day');
  endDate.add(7, 'day');
  return {start: startDate.toDate(), end: endDate.toDate()};
}

export function rangesAreEqual(a, b) {
  if (!a && !b) {
    return true;
  } else if (!a || !b) {
    return false;
  } else {
    return a.start.getTime() === b.start.getTime() && a.end.getTime() === b.end.getTime();
  }
}

export function combineParams(range, props) {
  return {
    orgId: props ? props.orgId : null,
    start: range ? range.start : null,
    end: range ? range.end : null,
  };
}

export function isOnline() {
  return isUndefined(navigator.onLine) ? true : navigator.onLine; // no way to know
}

export function getErrorMode() {
  return isOnline() ? ViewMode.EOTHER : ViewMode.ENONET;
}

export function returnSelf(i) {
  return i;
}



// WEBPACK FOOTER //
// ./src/js/calendar/utils/index.js